import {useSubheader} from "../../../_metronic/layout";
import React, {useEffect, useState} from "react";
import makeRequest from "../../api/makeRequest";
import {
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	Paper,
	Select,
	Table,
	TableBody,
	TableCell,
	TablePagination,
	TableRow,
	TextField
} from "@material-ui/core";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {useTranslation} from "react-i18next";
import {Button} from "react-bootstrap";

export const AddUserToRoomPage = ({match}) => {
	const { t } = useTranslation('common');
	const headRows = [
		{id: "id", disablePadding: true, label: t('Id')},
		{id: "name", disablePadding: false, label: t('Name')},
		{id: "username", disablePadding: false, label: t('AUTH.INPUT.USERNAME')},
		{id: "operation", disablePadding: false, label: t('MENU.ACTIONS')},
	];
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('UserAccess'));

	const {id: ID} = match.params

	const [selected, setSelected] = React.useState([]);
	const [RoomUsersSelected, setRoomUsersSelected] = React.useState([]);

	const [orderBy, setOrderBy] = React.useState("id");
	const [RoomUsersOrderBy, setRoomUsersOrderBy] = React.useState("id");

	const [order, setOrder] = React.useState("desc");
	const [RoomUsersOrder, setRoomUsersOrder] = React.useState("desc");

	const [page, setPage] = React.useState(0);
	const [RoomUsersPage, setRoomUsersPage] = React.useState(0);

	const [rowsPerPage, setRowsPerPage] = React.useState(50);
	const [RoomUsersRowsPerPage, setRoomUsersRowsPerPage] = React.useState(50);

	const [totalDocs, setTotalDocs] = React.useState(0);
	const [RoomUsersTotalDocs, setRoomUsersTotalDocs] = React.useState(0);

	const [Users, setUsers] = useState([])
	const [RoomUsers, setRoomUsers] = useState([])

	const [search,setSearch] = useState({})
	const [requestSearch,setRequestSearch] = useState(false)


	useEffect(() => {
		const getUsers = async () => {
			try {
				const query = {
					page: page + 1,
					per_page: rowsPerPage
				}
				const {data} = await makeRequest('getUsers', {search}, query)
				const users = data.users.docs
				setUsers(users)
				setTotalDocs(data.users.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getUsers()
	}, [page, rowsPerPage,requestSearch])
	useEffect(() => {
		const getRoomUsers = async () => {
			try {
				const query = {
					page: RoomUsersPage + 1,
					per_page: RoomUsersRowsPerPage
				}
				const {data} = await makeRequest('getRoomUsers', {
					"id": ID
				}, query)
				const roomUsers = data.users.docs
				setRoomUsers(roomUsers)
				setRoomUsersTotalDocs(data.users.totalDocs)
			} catch (e) {
				console.log(e)
			}
		}

		getRoomUsers()
	}, [RoomUsersPage, RoomUsersRowsPerPage])

	function handleSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = Users.map(n => n.name);
			setSelected(newSelecteds);
			return;
		}
		setSelected([]);
	}

	function handleRoomUsersSelectAllClick(event) {
		if (event.target.checked) {
			const newSelecteds = RoomUsers.map(n => n.name);
			setRoomUsersSelected(newSelecteds);
			return;
		}
		setRoomUsersSelected([]);
	}

	function handleRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setOrder(isDesc ? "asc" : "desc");
		setOrderBy(property);
	}

	function handleRoomUsersRequestSort(event, property) {
		const isDesc = orderBy === property && order === "desc";
		setRoomUsersOrder(isDesc ? "asc" : "desc");
		setRoomUsersOrderBy(property);
	}


	function stableSort(array, cmp) {
		const stabilizedThis = array.map((el, index) => [el, index]);
		stabilizedThis.sort((a, b) => {
			const order = cmp(a[0], b[0]);
			if (order !== 0) return order;
			return a[1] - b[1];
		});
		return stabilizedThis.map(el => el[0]);
	}

	function desc(a, b, orderBy) {
		if (b[orderBy] < a[orderBy]) {
			return -1;
		}
		if (b[orderBy] > a[orderBy]) {
			return 1;
		}
		return 0;
	}

	function getSorting(order, orderBy) {
		return order === "desc"
			? (a, b) => desc(a, b, orderBy)
			: (a, b) => -desc(a, b, orderBy);
	}

	const isSelected = name => selected.indexOf(name) !== -1;
	const isRoomUsersSelected = name => RoomUsersSelected.indexOf(name) !== -1;

	function handleClick(event, name) {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1)
			);
		}

		setSelected(newSelected);
	}

	function handleRoomUsersClick(event, name) {
		const selectedIndex = RoomUsersSelected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(RoomUsersSelected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(RoomUsersSelected.slice(1));
		} else if (selectedIndex === RoomUsersSelected.length - 1) {
			newSelected = newSelected.concat(RoomUsersSelected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				RoomUsersSelected.slice(0, selectedIndex),
				RoomUsersSelected.slice(selectedIndex + 1)
			);
		}

		setRoomUsersSelected(newSelected);
	}

	/*const emptyRows =
		rowsPerPage - Math.min(rowsPerPage, Users.length - page * rowsPerPage);

	const emptyRoomUsersRows =
		RoomUsersRowsPerPage - Math.min(RoomUsersRowsPerPage, RoomUsers.length - RoomUsersPage * RoomUsersRowsPerPage);
*/

	const emptyRows = 0

	const emptyRoomUsersRows = 0


	function handleChangePage(event, newPage) {
		setPage(newPage);
	}

	function handleRoomUsersChangePage(event, newPage) {
		setRoomUsersPage(newPage);
	}

	function handleChangeRowsPerPage(event) {
		setPage(0)
		setRowsPerPage(parseInt(event.target.value, 10));
	}

	function handleChangeRoomUsersRowsPerPage(event) {
		setRoomUsersPage(0)
		setRoomUsersRowsPerPage(parseInt(event.target.value, 10));
	}

	const addRoomUser = (user, roleId) => {
		makeRequest('addUsersToRoom', {
			"id": ID,
			"users": [{
				"user": user.id,
				"role": roleId
			}]
		}).then(({data}) => {
			if (data.success) {
				setRoomUsers(prev => [...prev, {
					...user,
					role: {
						id: roleId
					}
				}])
			} else {
				const {error} = data
				alert.error(error)
			}
		}).catch(() => {
			alert.error(t('Error'))
		})
	}
	const removeRoomUser = (userId) => {
		makeRequest('removeUsersFromRoom', {
			"id": ID,
			"users": [userId]
		}).then(({data}) => {
			if (data.success) {
				setRoomUsers(prev => prev.filter(q => q.id !== userId))
			} else {
				const {error} = data
				alert.error(error)
			}
		}).catch(() => {
			alert.error(t('Error'))
		})
	}
	const changeRoomUser = (user, roleId) => {
		makeRequest('addUsersToRoom', {
			"id": ID,
			"users": [{
				"user": user.id,
				"role": roleId
			}]
		}).then(({data}) => {
			if (data.success) {
				setRoomUsers(prev => prev.map(roomUser => {
					if (roomUser.id === user.id) roomUser.role.id = roleId
					return roomUser
				}))
			} else {
				const {error} = data
				alert.error(error)
			}
		}).catch(() => {
			alert.error(t('Error'))
		})
	}


	return (
		<>
			<Grid container spacing={2} justify="center" alignItems="baseline">
				<Grid item sm={6} xs={12}>
					<h2>{t('AddUserToRoom')}</h2>
					<SearchInputs
						onSearch={(e)=>{
							setSearch(e)
							setRequestSearch(prev=>!prev)
						}}
						showReset={JSON.stringify(search) !== "{}"}
					/>
					<Paper className={"classes.paper my-10"}>
						<div className={"tableWrapper"}>
							<Table
								className={"classes.table"}
								aria-labelledby="tableTitle"
								size={"medium"}
							>
								<EnhancedTableHead
									disableCheckbox
									numSelected={selected.length}
									order={order}
									orderBy={orderBy}
									onSelectAllClick={handleSelectAllClick}
									onRequestSort={handleRequestSort}
									rowCount={Users.length}
									headRows={headRows}
								/>
								<TableBody>
									{stableSort(Users.filter(q => {
										return !RoomUsers.find(ruQ => ruQ.id === q.id)
									}), getSorting(order, orderBy))
										.map((row, index) => {
											const isItemSelected = isSelected(row.id);
											const labelId = `enhanced-table-checkbox-${index}`;

											return (
												<TableRow
													hover
													onClick={event => handleClick(event, row.id)}
													role="checkbox"
													aria-checked={isItemSelected}
													tabIndex={-1}
													key={row.id}
													selected={isItemSelected}
												>
													<TableCell
														component="th"
														id={labelId}
														align="right"
													>
														{row.id}
													</TableCell>
													<TableCell align="right">{row.name}</TableCell>
													<TableCell align="right">{row.username}</TableCell>
													<TableCell align="right">
														<RoleSelect onAdd={(roleId) => addRoomUser(row, roleId)}/>
													</TableCell>
												</TableRow>
											);
										})}
									{emptyRows > 0 && (
										<TableRow style={{height: 85 * 2}}>
											<TableCell colSpan={6}/>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</div>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25, 50, 100, 250, 500]}
							component="div"
							labelRowsPerPage={t('NumberPerPage')}
							count={totalDocs}
							rowsPerPage={rowsPerPage}
							page={page}
							backIconButtonProps={{
								"aria-label": "Previous Page"
							}}
							nextIconButtonProps={{
								"aria-label": "Next Page"
							}}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					</Paper>
				</Grid>
				<Grid item sm={6} xs={12}>
					<h2 className='my-10'>{t('RoleUserToRoom')}</h2>
					<Paper className={"classes.paper"}>
						<div className={"tableWrapper"}>
							<Table
								className={"classes.table"}
								aria-labelledby="tableTitle"
								size={"medium"}
							>
								<EnhancedTableHead
									disableCheckbox
									numSelected={RoomUsersSelected.length}
									order={RoomUsersOrder}
									orderBy={RoomUsersOrderBy}
									onSelectAllClick={handleRoomUsersSelectAllClick}
									onRequestSort={handleRoomUsersRequestSort}
									rowCount={RoomUsers.length}
									headRows={headRows}
								/>
								<TableBody>
									{stableSort(RoomUsers, getSorting(RoomUsersOrder, RoomUsersOrderBy))
										.map((row, index) => {
											const isItemSelected = isRoomUsersSelected(row.id);
											const labelId = `RoomUsers-enhanced-table-checkbox-${index}`;

											return (
												<TableRow
													hover
													onClick={event => handleRoomUsersClick(event, row.id)}
													role="checkbox"
													aria-checked={isItemSelected}
													tabIndex={-1}
													key={row.id}
													selected={isItemSelected}
												>
													<TableCell
														component="th"
														id={labelId}
														align="right"
													>
														{row.id}
													</TableCell>
													<TableCell align="right">{row.name}</TableCell>
													<TableCell align="right">{row.username}</TableCell>
													<TableCell align="right">
														<RoleSelect
															defRole={row.role.id}
															onRemove={() => removeRoomUser(row.id)}
															onChange={(roleId) => changeRoomUser(row, roleId)}
															add={false}
														/>
													</TableCell>
												</TableRow>
											);
										})}
									{emptyRoomUsersRows > 0 && (
										<TableRow style={{height: 85 * emptyRoomUsersRows}}>
											<TableCell colSpan={6}/>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</div>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25, 50, 100, 250, 500]}
							component="div"
							labelRowsPerPage={t('NumberPerPage')}
							count={RoomUsersTotalDocs}
							rowsPerPage={RoomUsersRowsPerPage}
							page={RoomUsersPage}
							backIconButtonProps={{
								"aria-label": "Previous Page"
							}}
							nextIconButtonProps={{
								"aria-label": "Next Page"
							}}
							onChangePage={handleRoomUsersChangePage}
							onChangeRowsPerPage={handleChangeRoomUsersRowsPerPage}
						/>
					</Paper>
				</Grid>
			</Grid>
		</>
	)
}

const SearchInputs = React.memo(({onSearch,showReset=false})=>{
	const [name,setName] = useState('')
	const { t } = useTranslation('common')
	const [username,setUsername] = useState('')
	const [id,setId] = useState('')
	return(
		<div className='flex justify-content-between align-items-center my-5'>
			<form  onSubmit={(e)=> {
				e.preventDefault()
				onSearch({name, username, id})
			}}>
				<TextField onChange={(e)=>setName(e.target.value)} className='mx-2 my-2' label={t('Name')} variant="outlined"/>
				<TextField onChange={(e)=>setUsername(e.target.value)} className='mx-2 my-2' label={t('AUTH.INPUT.USERNAME')} variant="outlined"/>
				<TextField onChange={(e)=>setId(e.target.value)} className='mx-2 my-2' label={t('Id')} variant="outlined"/>
				<Button type='submit' className='mx-2 my-2' style={{lineHeight:"2.6"}}>{t('ECOMMERCE.COMMON.SEARCH')}</Button>
				{showReset ? <Button type='reset' onClick={()=>onSearch({})} className='mx-2 my-2' style={{lineHeight:"2.6"}} variant="outline-danger">{t('RemoveFilter')}</Button> : null}
			</form>

		</div>
	)
})

const RoleSelect = ({
											add = true, defRole = 1, onAdd = () => {
	}, onRemove = () => {
	}, onChange = () => {
	}
										}) => {
	const [roleId, setRoleId] = useState(defRole);
	const { t } = useTranslation('common');
	return (
		<Grid container spacing={2} justify="center" alignItems="center">
			<Grid item>
				<FormControl variant="outlined">
					<InputLabel htmlFor="outlined-age-native-simple">{t('Role')}</InputLabel>
					<Select
						native
						value={roleId}
						onChange={(e) => {
							setRoleId(e.target.value)
							if (!add) onChange(e.target.value)
						}}
						label={t('Role')}
						inputProps={{
							name: 'role',
							id: 'outlined-age-native-simple',
						}}
					>
						<option aria-label="None" value=""/>
						<option value={1}>{t('StudentRole')}</option>
						<option value={2}>{t('ProviderRole')}</option>
						<option value={3}>{t('MasterRole')}</option>
						<option value={4}>{t('AdminRole')}</option>
					</Select>
				</FormControl>
			</Grid>
			<Grid item>
				<IconButton onClick={() => add ? onAdd(roleId) : onRemove()} color={add ? "primary" : "secondary"}
										aria-label="change role" component="span">
					{add ? <AddIcon/> : <RemoveIcon/>}
				</IconButton>
			</Grid>
		</Grid>
	)
}